document.addEventListener('DOMContentLoaded', function () {
    const keywords = window.keywordData
    if (!keywords || !keywords.length) return

    const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    const pattern = keywords
        .map((k) => escapeRegExp(k.title))
        .sort((a, b) => b.length - a.length)
        .join('|')

    const regex = new RegExp(`\\b(${pattern})\\b`, 'gi')

    function walk(node) {
        if (!node) return

        if (node.nodeType === 3) {
            const text = node.nodeValue
            if (!regex.test(text)) return

            const wrapper = document.createElement('span')

            wrapper.innerHTML = text.replace(regex, (match) => {
                return `<span class="tooltipLinks cursor-pointer keyword" data-keyword="${match.toLowerCase()}">${match}</span>`
            })

            node.replaceWith(...wrapper.childNodes)
        } else if (
            node.nodeType === 1 &&
            !['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.tagName) &&
            !node.classList.contains('fui-i')
        ) {
            node.childNodes.forEach(walk)
        }
    }

    const container = document.querySelector('.entry-content') || document.body
    walk(container)

    document.body.addEventListener('click', function (e) {
        const el = e.target.classList.contains('keyword') ? e.target : null
        if (el === null) return
        if (el.closest('.fui-i')) return

        const keywordText = el.dataset.keyword

        const match = keywords.find((k) => k.title.toLowerCase() === keywordText)

        if (!el.querySelector('#tooltip-modal')) {
            document.querySelectorAll('#tooltip-modal')?.forEach((el) => {
                el.remove()
            })

            if (match) openModal(el, match)
        }
    })

    function openModal(el, data) {
        const modal = document.createElement('div')
        modal.id = 'tooltip-modal'
        modal.className = 'h-0 w-0 xl:float-left'

        modal.innerHTML = `
    <div class="tooltip-panel flex gap-4 items-start justify-between fixed max-xl:bottom-8 max-xl:left-8 xl:absolute xl:top-0 xl:rigth-full xl:-translate-x-[calc(100%+6rem)] max-w-xs p-6 w-full bg-white opacity-0 transition-all translate-y-full [&.show]:opacity-100 [&.show]:translate-y-0 pointer-events-auto">
        <div class="flex flex-col gap-4">
        <div class="body copy font-mono"></div>
        <div class="tooltipLink"></div>
        </div>
        <button class="close heading-4 cursor-pointer hover:scale-125 transition-all">×</button>
    </div>
    `

        el.append(modal)

        modal.querySelector('.close').onclick = closeModal

        modal.querySelector('.body').innerHTML = data.info

        const linkContainer = modal.querySelector('.tooltipLink')

        if (data.linkUrl) {
            linkContainer.innerHTML = `
        <a href="${data.linkUrl}" target="_blank" rel="noopener noreferrer" class="btn group">
            <span class="-text">${data.linkText || 'Read study'}</span>
            <span class="-icon
                [&amp;_.icon:first-child]:-translate-y-full
                [&amp;_.icon:first-child]:translate-x-full
                [&amp;_.icon:first-child]:group-hover:translate-y-0
                [&amp;_.icon:first-child]:group-hover:translate-x-0
                [&amp;_.icon:last-child]:translate-y-0
                [&amp;_.icon:last-child]:translate-x-0
                [&amp;_.icon:last-child]:group-hover:translate-y-full
                [&amp;_.icon:last-child]:group-hover:-translate-x-full order-2"
            >
                <span class="icon icon-outline-arrow-right-up button__icon size-3">
                    <svg><use xlink:href="#outline/arrow-right-up"></use></svg>
                </span>
                <span class="icon icon-outline-arrow-right-up button__icon size-3">
                    <svg><use xlink:href="#outline/arrow-right-up"></use></svg>
                </span>
            </span>
        </a>
        `
        }

        const panel = modal.querySelector('.tooltip-panel')

        panel.classList.remove('show')
        void panel.offsetWidth
        panel.classList.add('show')
    }

    function closeModal() {
        if (!modal) return
        const panel = modal.querySelector('.tooltip-panel')
        panel.classList.remove('show')
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal()
    })
})

/* Open all richtext link in new tab */
const observer = new MutationObserver(() => {
    document.querySelectorAll('.richtext a:not([target])').forEach((link) => {
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noopener noreferrer')
    })
})

observer.observe(document.body, { childList: true, subtree: true })
